import io from 'socket.io-client';
import { resolveStoredAuthToken } from '../utils/storage';
import { API_BASE_URL } from '../config/apiBase';

let sharedSocket = null;
let sharedToken = null;

const normalizeToken = (token) => {
  if (typeof token !== 'string') return '';
  return token.trim();
};

export const initializeSocket = (explicitToken = null) => {
  const token = normalizeToken(resolveStoredAuthToken(explicitToken));
  if (!token) return null;

  if (sharedSocket && sharedToken === token) {
    return sharedSocket;
  }

  if (sharedSocket) {
    sharedSocket.disconnect();
    sharedSocket = null;
    sharedToken = null;
  }

  sharedSocket = io(API_BASE_URL, {
    auth: {
      token: `Bearer ${token}`,
    },
    transports: ['websocket'],
  });
  sharedToken = token;
  return sharedSocket;
};

export const subscribeToFeedUpdates = (socket, handlers = {}) => {
  if (!socket) return () => {};

  const {
    onPostCreated,
    onPostUpdated,
    onCommentAdded,
    onLikeUpdated,
    onPostChange,
  } = handlers;

  const subscriptions = [];

  if (typeof onPostCreated === 'function') {
    socket.on('post-created', onPostCreated);
    subscriptions.push(['post-created', onPostCreated]);
  } else if (typeof onPostChange === 'function') {
    socket.on('post-created', onPostChange);
    subscriptions.push(['post-created', onPostChange]);
  }

  if (typeof onPostUpdated === 'function') {
    socket.on('post-updated', onPostUpdated);
    subscriptions.push(['post-updated', onPostUpdated]);
  } else if (typeof onPostChange === 'function') {
    socket.on('post-updated', onPostChange);
    subscriptions.push(['post-updated', onPostChange]);
  }

  if (typeof onCommentAdded === 'function') {
    socket.on('comment-added', onCommentAdded);
    subscriptions.push(['comment-added', onCommentAdded]);
  } else if (typeof onPostChange === 'function') {
    socket.on('comment-added', onPostChange);
    subscriptions.push(['comment-added', onPostChange]);
  }

  if (typeof onLikeUpdated === 'function') {
    socket.on('like-updated', onLikeUpdated);
    subscriptions.push(['like-updated', onLikeUpdated]);
  } else if (typeof onPostChange === 'function') {
    socket.on('like-updated', onPostChange);
    subscriptions.push(['like-updated', onPostChange]);
  }

  return () => {
    subscriptions.forEach(([eventName, handler]) => {
      socket.off(eventName, handler);
    });
  };
};

export const subscribeToPostUpdates = (socket, callback) => {
  return subscribeToFeedUpdates(socket, { onPostChange: callback });
};

export const disconnectSocket = (socket, { force = false } = {}) => {
  if (!socket) return;
  if (force || socket !== sharedSocket) {
    socket.disconnect();
  }
  if (force && socket === sharedSocket) {
    sharedSocket = null;
    sharedToken = null;
  }
};

export const resetSharedSocket = () => {
  if (sharedSocket) {
    sharedSocket.disconnect();
  }
  sharedSocket = null;
  sharedToken = null;
};
